import React, { FunctionComponent, SVGProps } from "react";
import { motion } from "framer-motion";

interface LogoProps extends SVGProps<SVGSVGElement> {
  className?: string;
  noAnimation?: boolean;
  color?: string;
}

export const LogoIcon: FunctionComponent<LogoProps> = ({
  className,
  noAnimation,
  color,
  ...props
}) => {
  const logoMotion = {
    rest: { scale: 1 },
    hover: { scale: 1.125 },
    tap: { scale: 0.85, scaleX: 1 },
  };

  return (
    <motion.div initial="rest" whileHover="hover" whileTap="tap" animate="rest">
      <svg
        width="86"
        height="19"
        viewBox="0 0 86 19"
        className={className || ""}
        style={{ overflow: "visible" }}
        {...props}
      >
        <motion.path
          fill={color ? color : undefined}
          variants={noAnimation ? undefined : logoMotion}
          transition={{ type: "spring", duration: 0.75, bounce: 0.5 }}
          d="M17.31,8.71,8.66,0v8.7L0,0V14.74L4.24,19V10.3L12.9,19V10.3L21.55,19V4.26L17.31,0Z"
        />
        <path
          fill={color ? color : undefined}
          d="M31.58,0,27.94,3.65V13.76c0,3.11,1.41,5.13,5.44,5.13a10.78,10.78,0,0,0,3-.4V15.57a8.61,8.61,0,0,1-2.09.26c-1.83,0-2.7-.82-2.7-2.64V7.74h4.79V4.42H31.58Z"
        />
        <path
          fill={color ? color : undefined}
          d="M41.89,8.13V4.42H38.57V18.57H42.2V13.06a6.07,6.07,0,0,1,1.38-4.45,4.56,4.56,0,0,1,3.47-1.19,6.71,6.71,0,0,1,1.1.09V4.14a5.86,5.86,0,0,0-1-.09A5.33,5.33,0,0,0,41.89,8.13Z"
        />
        <path
          fill={color ? color : undefined}
          d="M64.16,18.57V10c0-4.1-2.31-6-7.3-6C52.4,4,49.44,6,49.1,9.06h3.81c.22-1.67,1.63-2.57,3.94-2.57s3.64,1,3.64,3v.32l-5.05.42c-2.64.25-4.06.65-5.07,1.3a3.62,3.62,0,0,0-1.72,3.2c0,2.63,2.23,4.25,5.72,4.25,3.1,0,5.3-1.1,6.26-3v2.58Zm-3.62-6c0,2.41-2,4-5,4-2,0-3.15-.73-3.15-2s.9-2,3.35-2.21l4.76-.48Z"
        />
        <path
          fill={color ? color : undefined}
          d="M74.35,6.74c2.28,0,3.75,1.08,4.17,3h0l3.4-1.56C80.94,5.49,78.31,4,74.46,4c-5.16,0-8.4,2.86-8.4,7.47S69.33,19,74.4,19c3.77,0,6.52-1.6,7.54-4.27L78.6,13.2a3.89,3.89,0,0,1-4.2,3c-2.81,0-4.56-1.79-4.56-4.79S71.53,6.74,74.35,6.74Z"
        />
        <path
          fill={color ? color : undefined}
          d="M85.86,4.75a2.07,2.07,0,0,0-.39-.54,2.15,2.15,0,0,0-.56-.34,1.93,1.93,0,0,0-1.34,0,1.68,1.68,0,0,0-.56.34,1.73,1.73,0,0,0-.4.57,1.61,1.61,0,0,0-.13.68,1.63,1.63,0,0,0,.14.72,1.5,1.5,0,0,0,.39.54,1.53,1.53,0,0,0,.56.34,1.93,1.93,0,0,0,1.34,0,1.72,1.72,0,0,0,.56-.34,1.64,1.64,0,0,0,.4-.57A1.8,1.8,0,0,0,86,5.46,2,2,0,0,0,85.86,4.75ZM85.43,6a1.39,1.39,0,0,1-.28.43,1.07,1.07,0,0,1-.41.28,1.21,1.21,0,0,1-1,0,1.07,1.07,0,0,1-.41-.28A1.23,1.23,0,0,1,83,6a1.57,1.57,0,0,1,0-1.09,1.19,1.19,0,0,1,.28-.42,1,1,0,0,1,.41-.28,1.21,1.21,0,0,1,1,0,1,1,0,0,1,.41.28,1.34,1.34,0,0,1,.28.42A1.47,1.47,0,0,1,85.43,6Z"
        />
        <path
          fill={color ? color : undefined}
          d="M84.72,5.54a.42.42,0,0,0,.16-.09A.33.33,0,0,0,85,5.3a.62.62,0,0,0,0-.23.43.43,0,0,0,0-.25.48.48,0,0,0-.15-.2,1,1,0,0,0-.56-.12h-.73V6.43h.38V5.6h.25l.47.83h.4l-.51-.85Zm-.79-.24V4.79h.46l.13,0a.16.16,0,0,1,.09.07.19.19,0,0,1,0,.12c0,.12,0,.19-.1.23a.86.86,0,0,1-.28,0Z"
        />
      </svg>
    </motion.div>
  );
};
